import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { get } from 'helpers/apiHelpers';

export type BrandTermType = 'EMAIL' | 'SMS' | 'PHONE';

type BrandTerm = {
  type: BrandTermType;
  active: boolean;
};

type BrandTermsResponse = {
  'hydra:member': BrandTerm[];
};

export type BrandConsentsAvailability = {
  [type in BrandTermType]: boolean;
};

const NOTHING_AVAILABLE: BrandConsentsAvailability = {
  EMAIL: false,
  SMS: false,
  PHONE: false,
};

const isTermActive = (brandTerms: BrandTerm[], type: BrandTermType) =>
  brandTerms.find(term => term.type === type)?.active ?? false;

const useBrandConsentsAvailability = (): BrandConsentsAvailability => {
  const { t } = useTranslation();
  const [availability, setAvailability] = useState(NOTHING_AVAILABLE);

  useEffect(() => {
    let isMounted = true;

    const fetchBrandTerms = async () => {
      try {
        const { 'hydra:member': brandTerms }: BrandTermsResponse = await get(
          '/brand-terms'
        );

        if (isMounted) {
          setAvailability({
            EMAIL: isTermActive(brandTerms, 'EMAIL'),
            SMS: isTermActive(brandTerms, 'SMS'),
            PHONE: isTermActive(brandTerms, 'PHONE'),
          });
        }
      } catch {
        if (isMounted) {
          toast.error(t('discountCodes.info7'));
        }
      }
    };

    fetchBrandTerms();

    return () => {
      isMounted = false;
    };
  }, [t]);

  return availability;
};

export default useBrandConsentsAvailability;
